export const CAMERA_NEAR = 0.01;
export const CAMERA_FAR = 1000;
